import type { Column, ColumnRenderer } from '@axinom/mosaic-ui';
import type { ServiceDeploymentCondition } from 'generated/hosting-service';
import type { ReactNode } from 'react';

export interface LastDeployment
  extends NonNullable<ServiceDeploymentCondition> {
  manifest: string;
  servicePiletArtifacts: string;
}

export const renderPiletArtifacts: ColumnRenderer<LastDeployment> = (
  _value,
  data,
): ReactNode => {
  return typeof data.servicePiletArtifacts === 'string' &&
    data.servicePiletArtifacts !== ''
    ? data.servicePiletArtifacts
    : 'None';
};

const commonColumns: Column<LastDeployment>[] = [
  {
    propertyName: 'containerImageVersion',
    label: 'Container Image Version',
    sortable: false,
  },
  {
    propertyName: 'servicePiletArtifacts',
    label: 'Pilet Artifact',
    sortable: false,
    render: renderPiletArtifacts,
  },
];

export const generateCurrentDeploymentColumns = (
  isAxinomOwnedService: boolean,
): Column<LastDeployment>[] => {
  return isAxinomOwnedService
    ? [
        ...commonColumns,
        {
          propertyName: 'manifest',
          label: 'Deployment Manifest Timestamp',
          sortable: false,
        },
      ]
    : [
        {
          propertyName: 'name',
          label: 'Name',
          sortable: false,
        },
        ...commonColumns,
        {
          propertyName: 'manifest',
          label: 'Deployment Manifest Name',
          sortable: false,
        },
      ];
};

export const generateUpgradeAvailabilityColumns =
  (): Column<LastDeployment>[] => {
    return [
      ...commonColumns,
      {
        propertyName: 'manifest',
        label: 'Deployment Manifest Timestamp',
        sortable: false,
      },
    ];
  };
